import axios, {
  AxiosRequestConfig,
  AxiosInstance,
  AxiosResponse,
  AxiosError
} from "axios";

export interface HTTPClientOptions {
  baseURL: string;
  tokenURL: string;
  // retokenURL: string;
}

export interface SetupTokenParams {
  email: string;
  password: string;
}

export interface OAuthToken {
  accessToken: string;
  // refreshToken: string;
}

export class HTTPClient {
  private client: AxiosInstance;
  private baseURL: string;
  private tokenURL: string;
  // private retokenURL: string;

  public accessToken: string | undefined;
  // public refreshToken: string | undefined;
  // private isRefreshingAccessToken = false;
  // private retryRequestTasks: RetryRequestTasks[] = [];

  constructor({ baseURL, tokenURL }: HTTPClientOptions) {
    this.baseURL = baseURL;
    this.tokenURL = tokenURL;
    // this.retokenURL = retokenURL;

    this.accessToken = this.cacheAccessToken;
    // this.refreshToken = this.cacheRefreshToken;

    this.client = axios.create({
      baseURL
    });

    this.setupClient();
  }

  public async request<T>(
    config: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    const configWithAuthorization = this.configWithAuthorization(
      config,
      this.accessToken
    );

    const result = await this.client.request(configWithAuthorization);

    return result;
  }

  public async setupToken(data: SetupTokenParams): Promise<void> {
    const { data: response } = await this.client.request({
      url: this.tokenURL,
      method: "POST",
      data
    });

    this.setToken(response.data);
  }

  public setToken(token: OAuthToken) {
    this.accessToken = token.accessToken;
    this.cacheAccessToken = token.accessToken;
    // this.refreshToken = token.refreshToken;
    // this.cacheRefreshToken = token.refreshToken;
  }

  public async clearToken(): Promise<void> {
    this.accessToken = undefined;
    this.cacheAccessToken = undefined;
    // this.refreshToken = undefined;
    // this.cacheRefreshToken = undefined;
  }

  public hasAccessToken() {
    return !!this.cacheAccessToken;
  }

  private setupClient() {
    this.client.interceptors.response.use(
      response => response,
      error => {
        if (!this.isAxiosError(error) && !this.isAuthenticationError(error)) {
          return Promise.reject(error);
        }

        if (this.isAccessTokenExpired(error)) {
          window.location.href = window.location.origin + "/auth/login";
        }

        // if (this.refreshTokenErrorOrForbiden(error)) {
        //   this.clearToken();
        //   window.location.href = window.location.origin + "/auth/login";
        // }

        // if (!this.isRefreshingAccessToken) {
        //   this.isRefreshingAccessToken = true;
        //   this.refreshAccessToken().then(
        //     this.handleRefreshAccessTokenSuccess.bind(this),
        //     this.handleRefreshAccessTokenFail.bind(this)
        //   );
        // }
        // const retry = this.retry(error);
        // return retry;

        return Promise.reject(error);
      }
    );
  }

  private isAxiosError(error: Error): error is AxiosError {
    const { isAxiosError }: AxiosError = error as AxiosError;

    return isAxiosError;
  }

  private isAuthenticationError(error: AxiosError): boolean | undefined {
    return (
      error.config &&
      error.config.url === this.tokenURL &&
      error.response &&
      error.response.status === 401
    );
  }

  private isAccessTokenExpired(error: AxiosError): boolean | undefined {
    return (
      error.config &&
      // error.config.url !== this.retokenURL &&
      error.config.url !== this.tokenURL &&
      error.response &&
      error.response.status === 401
    );
  }

  // private refreshTokenErrorOrForbiden(error: AxiosError): boolean | undefined {
  //   return (
  //     (error.config && error.config.url === this.retokenURL) ||
  //     (error.response && error.response.status === 403)
  //   );
  // }

  // private async refreshAccessToken(): Promise<void> {
  //   const config = this.configWithAuthorization(
  //     {
  //       url: this.retokenURL,
  //       method: "POST",
  //     },
  //     this.refreshToken
  //   );
  //   const { data: response } = await this.client.request(config);
  //   this.accessToken = response.data.accessToken;
  //   this.cacheAccessToken = response.data.accessToken;
  // }

  // private retry<T>(error: AxiosError<T>): Promise<AxiosResponse<T>> {
  //   return new Promise((resolve, reject) => {
  //     this.retryRequestTasks.push((accessTokenOrError) => {
  //       if (typeof accessTokenOrError !== "string") {
  //         reject(accessTokenOrError);
  //         return;
  //       }

  //       const config = { ...error.config };
  //       config.headers = this.injectAuthorizationToken(
  //         error.config.headers,
  //         accessTokenOrError
  //       );

  //       resolve(this.client.request(config));
  //     });
  //   });
  // }

  private configWithAuthorization(
    config: AxiosRequestConfig,
    token: string | undefined
  ): AxiosRequestConfig {
    const { headers = {} } = config;

    if (headers.Authorization) {
      return config;
    }
    return {
      ...config,
      headers: this.injectAuthorizationToken(headers, token)
    };
  }

  private injectAuthorizationToken(
    headers: Record<string, string>,
    token: string | undefined
  ): Record<string, string> {
    return { ...headers, Authorization: `Bearer ${token}` };
  }

  // private retryRequestQueues(accessTokenOrError: string | Error): void {
  //   this.retryRequestTasks.forEach((queue) => queue(accessTokenOrError));

  //   this.retryRequestTasks = [];
  // }

  // private handleRefreshAccessTokenSuccess() {
  //   this.isRefreshingAccessToken = false;
  //   this.retryRequestQueues(this.accessToken || "");
  // }

  private get cacheAccessToken(): string | undefined {
    return (
      localStorage.getItem("mycloud_super_tools::accessToken") || undefined
    );
  }

  private set cacheAccessToken(token: string | undefined) {
    if (typeof token === "undefined") {
      localStorage.removeItem("mycloud_super_tools::accessToken");
      return;
    }

    localStorage.setItem("mycloud_super_tools::accessToken", token);
  }

  // private handleRefreshAccessTokenFail(error: Error) {
  //   this.isRefreshingAccessToken = false;
  //   this.retryRequestQueues(error);
  // }

  // private get cacheRefreshToken(): string | undefined {
  //   return localStorage.getItem("refreshToken") || undefined;
  // }
  // private set cacheRefreshToken(token: string | undefined) {
  //   if (typeof token === "undefined") {
  //     localStorage.removeItem("refreshToken");
  //     return;
  //   }

  //   localStorage.setItem("refreshToken", token);
  // }
}
